import React from 'react';
import { injectIntl, defineMessages, IntlShape } from 'react-intl';

import DialogContent from '@material-ui/core/DialogContent';
import Grid from '@material-ui/core/Grid';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

import ClosableDialog from '../ClosableDialog';
import { IconLocked, IconNotification, IconShareScreen } from '../IconSet';

import PushNotificationsSwitch from './PushNotificationsSwitch';
import RoomLockPreferenceSwitch from './RoomLockPreferenceSwitch';
import ScreenshareSlider from './ScreenshareFrameRateSlider';


const messages = defineMessages({
  title: { id: 'userOther' }
});


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      overflow: 'hidden',
      paddingBottom: theme.spacing(2),
    },
    container: {
      padding: theme.spacing(1),
    },
    icons: {
      textAlign: 'center',
      alignSelf: 'center',
    }
  })
);


type Props = {
  onClose: () => void;
};


type ExtendedProps = Props & { intl: IntlShape };


function UserOther(props: ExtendedProps) {
  const classes = useStyles();

  return (
    <ClosableDialog
      open={true}
      onClose={props.onClose}
      title={props.intl.formatMessage(messages.title)}
      fullWidth
    >
      <DialogContent className={classes.root}>
        <Grid container spacing={2}>
          <Grid container item xs={12} spacing={2}>
            <Grid item xs={2} className={classes.icons}>
              <IconLocked size={24} />
            </Grid>
            <Grid item xs={10}>
              <RoomLockPreferenceSwitch />
            </Grid>
          </Grid>
          <Grid container item xs={12} spacing={2}>
            <Grid item xs={2} className={classes.icons}>
              <IconShareScreen size={24} />
            </Grid>
            <Grid item xs={10}>
              <ScreenshareSlider />
            </Grid>
          </Grid>
          <Grid container item xs={12} spacing={2}>
            <Grid item xs={2} className={classes.icons}>
              <IconNotification size={24} />
            </Grid>
            <Grid item xs={10}>
              <PushNotificationsSwitch />
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
    </ClosableDialog>
  );
}

export default injectIntl(UserOther);
